import { CircularProgress } from '@material-ui/core';
import { Cancel, GetApp, PlayArrowRounded } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  getBookingRecordingsBrowser,
  getBookingRecordings,
  getBookings,
} from '../../../services/apiService';
import { BytesToMetricSize } from '../../../utils';
import DetailsHeader from '../_components/DetailsHeader';

const VideoInfo = ({ recordings, setPlayRecording, title }) => (
  <>
    <h2 className='text-center font-medium text-2xl mt-4 mb-8'>
      {recordings.length} {title}
    </h2>
    {recordings.map((recording, index) => (
      <div
        className='bg-white rounded-lg max-w-lg flex gap-4 mx-auto my-4 p-4'
        key={index}
      >
        <span
          onClick={() => setPlayRecording(recording)}
          className='bg-green-c1 text-white rounded-full flex items-center justify-center h-12 w-12 cursor-pointer'
        >
          <PlayArrowRounded color='inherit' fontSize='large' />
        </span>

        <div>
          <div className='font-medium'>Recording {index + 1}</div>
          <div className='text-sm opacity-60 mt-1'>
            {moment(recording.LastModified).format('DD MMM YYYY, hh:mm A')}
          </div>
        </div>

        <button
          onClick={() => window.open(recording.url, '_blank')}
          className='ml-auto my-auto text-blue-c1'
        >
          <GetApp color='inherit' fontSize='large' />
          <span className='ml-1 text-sm'>
            {BytesToMetricSize(recording.Size)}
          </span>
        </button>
      </div>
    ))}
  </>
);
export default function WatchRecording(props) {
  const [booking, setBooking] = useState(null);
  const [recordings, setRecordings] = useState(null);
  const [recordingsBR, setRecordingsBR] = useState(null);
  const [playRecording, setPlayRecording] = useState(null);

  useEffect(() => {
    const init = async () => {
      try {
        let booking = props.location.state?.booking;
        if (booking) {
          setBooking(booking);
        } else {
          const bookingId = props.match.params?.bookingId;
          const response = await getBookings({
            bookingId,
            includeStudent: true,
            includeCoach: true,
            includeSubTopic: true,
          });

          if (response?.items?.length) {
            booking = response.items[0];
            setBooking(response.items[0]);
          } else throw new Error('Booking not found');
        }
        const response = await getBookingRecordings(booking.roomId100ms);
        if (Array.isArray(response)) setRecordings(response);
        else throw new Error('Recordings not found');

        const responseBR = await getBookingRecordingsBrowser(
          booking.roomId100ms
        );
        if (Array.isArray(responseBR)) setRecordingsBR(responseBR);
        else throw new Error('Recordings not found');
      } catch (err) {
        console.error(err);
        toast.error('Failed to fetch details, please try again later!');
      }
    };

    init();
  }, []);

  return booking ? (
    <div>
      <h1 className='text-3xl font-semibold tracking-wide'>Watch Recordings</h1>
      <DetailsHeader booking={booking} hideWatchRecordingButton />
      <div className='flex flex-row justify-center space-x-10 '>
        <div className=''>
          {recordings ? (
            <VideoInfo
              recordings={recordings}
              setPlayRecording={setPlayRecording}
              title='Recordings Available'
            />
          ) : (
            <div className='flex items-center justify-center text-blue-c1 dark:text-ab-tertiary py-16'>
              <CircularProgress color='inherit' />
            </div>
          )}
        </div>

        <div className=''>
          {recordingsBR ? (
            <VideoInfo
              recordings={recordingsBR}
              setPlayRecording={setPlayRecording}
              title='Browser Recordings Available'
            />
          ) : (
            <div className='flex items-center justify-center text-blue-c1 dark:text-ab-tertiary py-16'>
              <CircularProgress color='inherit' />
            </div>
          )}
        </div>
      </div>
      {playRecording && (
        <div className='fixed inset-0 flex flex-col items-center justify-center gap-4 bg-black bg-opacity-80'>
          <div className='relative'>
            <video
              src={playRecording.url}
              type='video/mp4'
              height='720'
              width='1280'
              className='focus:outline-none ring-1 ring-green-c1 ring-opacity-40 rounded-lg'
              autoPlay
              controls
            />
            <button
              onClick={() => setPlayRecording(null)}
              className='absolute top-3 right-3 bg-white rounded-full flex'
            >
              <Cancel />
            </button>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className='flex items-center justify-center text-blue-c1 dark:text-ab-tertiary h-75h mt-20'>
      <CircularProgress color='inherit' />
    </div>
  );
}
